import { SERVICES_API_BASE_URL } from './apiConfig';

export interface StripeConnection {
  stripeAccountId?: string;
  isConnected: boolean;
  connectedAt?: string;
}

export interface StripeAuthorizationResponse {
  stripeAccountId: string;
  isConnected: boolean;
  connectedAt?: string;
}

const getAuthHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

/**
 * Get Stripe connection status.
 */
export const getStripeConnection = async (): Promise<StripeConnection | null> => {
  const response = await fetch(
    `${SERVICES_API_BASE_URL}/api/stripeconnect/status`,
    {
      headers: getAuthHeader(),
    }
  );

  if (!response.ok) {
    return null;
  }

  return response.json();
};

/**
 * Retrieve Stripe OAuth URL.
 */
export const getStripeConnectUrl = async (): Promise<string> => {
  const response = await fetch(
    `${SERVICES_API_BASE_URL}/api/stripeconnect/connect-url`,
    {
      headers: getAuthHeader(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to retrieve Stripe connect URL');
  }

  const data = await response.json();

  return data.connectUrl;
};

/**
 * Complete Stripe OAuth flow.
 */
export const authorizeStripe = async (
  authCode: string
): Promise<StripeAuthorizationResponse> => {
  const response = await fetch(
    `${SERVICES_API_BASE_URL}/api/stripeconnect/authorize`,
    {
      method: 'POST',
      headers: getAuthHeader(),
      body: JSON.stringify({
        authCode,
      }),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to authorize Stripe account');
  }

  return response.json();
};

/**
 * Disconnect Stripe account.
 */
export const disconnectStripe = async (): Promise<void> => {
  const response = await fetch(
    `${SERVICES_API_BASE_URL}/api/stripeconnect/disconnect`,
    {
      method: 'POST',
      headers: getAuthHeader(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to disconnect Stripe account');
  }
};